/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/6
 */
import {takeLatest, call, put, all} from 'redux-saga/effects';
import {
  GET_HOT,
  GET_HOME,
  GET_PRODUCT,
  GET_CATEGORY,
  GET_PAGE_INFO,
  GET_HOME_BY_CID,
  receiveCategory,
  receiveProduct,
  receiveBrand,
  receiveHot,
  changeBid,
  changeCid,
  receivePageInfo
} from '../actions/home';
import { addDialog } from '../actions/app';
import * as homeService from '../services/home';
const SERVER_ERR = '服务器繁忙';

/**
 * get homepage init data
 */
export function* getHome() {
  try {
    const resp = yield call(homeService.getHome);
    if (resp.success) {
      const brand = resp.data.brand;
      const category = resp.data.category;
      yield [
        put(receiveBrand({current: brand[0].id, list: brand})),
        put(receiveProduct(resp.data.product)),
        put(receiveCategory({current: category[0].id, list: category}))
      ];
    } else {
      return yield put(addDialog(SERVER_ERR));
    }
  } catch (e) {
    yield put(addDialog());
    console.error(`SAGAS_HOME_GETHOME ERROR: ${e.stack}`);
  }
}

/**
 * get homepage hot product data
 */
export function* getHot() {
  try {
    const resp = yield call(homeService.getHot);
    if (resp.success) {
      yield put(receiveHot(resp.data));
    } else {
      yield put(addDialog(SERVER_ERR));
    }
  } catch (e) {
    yield put(addDialog());
    console.error(`SAGAS_HOME_GETHOT ERROR: ${e.stack}`)
  }
}

/**
 * get homepage data by category id
 */
export function* getHomeByCid(action) {
  try {
    const resp = yield call(homeService.getHomeByCid, action.cid, action.current);
    if (action.bid) {
      var pResp = yield call(homeService.getProduct, action.cid, action.bid, action.current);
    }
    if (resp.success) {
      const brand = resp.data.brand;
      const product = action.bid ? pResp.data.product : resp.data.product;
      const currentBid = action.bid ? action.bid : brand[0].id;
      yield [
        put(receiveBrand({current: currentBid, list: brand})),
        put(receiveProduct(product)),
        put(changeCid(action.cid))
      ]
    } else {
      yield put(addDialog(SERVER_ERR));
    }
  } catch(e) {
    yield put(addDialog());
    console.error(`SAGAS_HOME_GETHOMEBYCID ERROR: ${e.stack}`);
  }
}

/**
 * get category data
 */
export function* getCategory(action) {
  try {
    const resp = yield call(homeService.getCategory, action.cid);
    if (resp.success) {
      const category = resp.data;
      const current = action.cid ? action.cid : category[0].id;
      yield put(receiveCategory({ current: current, list: category }));
    } else {
      yield put(addDialog(SERVER_ERR));
    }
  } catch (e) {
    yield put(addDialog());
    console.error(`SAGAS_HOME_GETCATEGORY ERROR: ${e.stack}`);
  }
}

/**
 * get product data by category id & brand id
 */
export function* getProduct(action) {
  try {
    const resp = yield call(homeService.getProduct, action.cid, action.bid, action.current);
    if (resp.success) {
      yield put(receiveProduct(resp.data.product));
      yield put(changeBid(action.bid));
      yield put(changeCid(action.cid));
    } else {
      yield put(addDialog(SERVER_ERR));
    }
  } catch(e) {
    yield put(addDialog());
    console.error(`SAGAS_HOME_GETPRODUCT ERROR: ${e.stack}`);
  }
}

/**
 * get page info data(banner & qa)
 */
export function* getPageInfo(action) {
  try {
    const resp = yield call(homeService.getPageInfo, action.isPreview);
    if (resp.success) {
      yield put(receivePageInfo(resp.data));
    } else {
      yield put(addDialog(SERVER_ERR));
    }
  } catch (e) {
    yield put(addDialog());
    console.error(`SAGAS_HOME_GETPAGEINFO ERROR: ${e.stack}`);
  }
}

export function* watchHome() {
  yield all([
    takeLatest(GET_HOME, getHome),
    takeLatest(GET_HOT, getHot),
    takeLatest(GET_HOME_BY_CID, getHomeByCid),
    takeLatest(GET_CATEGORY, getCategory),
    takeLatest(GET_PRODUCT, getProduct),
    takeLatest(GET_PAGE_INFO, getPageInfo)
  ])
}



// WEBPACK FOOTER //
// ./src/sagas/home.js